import { useMemo } from "react";

import { useConnection } from "@/components/features/items/edit/_shared/ui/components/main/questions/connection/hooks";

import { useProductPlanFormModelContext } from "../../../../../context";

export const usePlanRequiredOptionIDs = () => {
	const { viewModel, onSetViewModel, queryData } = useProductPlanFormModelContext();
	const { availableOptionIDs, requiredOptionIDs, hotelID } = viewModel;
	const { optionNameAndIDOptions } = queryData.connection;

	const rawAvailableOptionsIDs = availableOptionIDs.value.map((item) => item.value);
	const requiredOptionsNameAndIDOptions = useMemo(
		() => optionNameAndIDOptions.filter((item) => rawAvailableOptionsIDs.includes(item.value)),
		[optionNameAndIDOptions, rawAvailableOptionsIDs],
	);

	const isEdited = useMemo(() => {
		return requiredOptionIDs.isEdited;
	}, [requiredOptionIDs.isEdited]);

	return {
		...useConnection<"requiredOptionIDs">({
			availableItemIDs: requiredOptionIDs, //
			nameAndIDOptions: requiredOptionsNameAndIDOptions,
			keyOfValue: "requiredOptionIDs",
			onSetViewModel,
		}),
		hotelID,
		isEdited,
	};
};
